export default __webpack_public_path__ + "static/media/YASKAWA MOTOMAN.377bee2e.png";